import React from "react";
import PropTypes from "prop-types";
import { WarningBlock } from "./WarningBlock";
import { Heading } from "./Heading";
import { InstructionContent } from "./InstructionContent";
import warningIcon from "./icons/warning.svg";
import { useTranslation } from "react-i18next";

import "./style.scss";

/**
 *  FrontViewContent:
 *    to render the contents (settings and display) for front view of microcentrfige Modal view
 */
export function FrontViewContent() {
  const { t } = useTranslation();

  return (
    <div className="mc_frontview_wrapper">
      <Heading className="mc_frontview_instruction_header" />
      <InstructionContent className="mc_frontview_instruction_text" />
      <div className="mc_frontview_instruction_warning">
        <h5 className="warningHeading">
          <img src={warningIcon} alt="" />
          {t("doubleCheck.string")}
        </h5>
        <h6 className="warningSubHeading">{t("balanceWarning.string")}</h6>
        <WarningBlock />
      </div>
    </div>
  );
}

FrontViewContent.propTypes = {
  /**
   * data for settings block
   */
  data: PropTypes.shape({
    settings: PropTypes.shape({
      /**
       * value for rpm block
       */
      rpmValue: PropTypes.number,
      /**
       * value for timer block
       */
      timerValue: PropTypes.instanceOf(Date),
    }),
  }),
  /**
   * callback function to run centrifuge
   */
  onRunCentrifuge: PropTypes.func,
  /**
   * callback function to stop centrifuge
   */
  onStopCentrifuge: PropTypes.func,
  /**
   * callback function to set rpm value
   */
  setRPM: PropTypes.func,
  /**
   * callback function to set timer value
   */
  setTimer: PropTypes.func,
};

FrontViewContent.defaultProps = {};
